import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const faqs = [
  {
    question: 'Was kostet ein Elektriker in Bonn für eine Altbausanierung?',
    answer: 'Die Kosten für Elektroarbeiten oder eine Elektroinstallation im Altbau in Bonn hängen immer vom Umfang der Arbeiten ab. Nach einem kostenlosen Vor-Ort-Termin erstellen wir Ihnen ein transparentes Angebot – ohne versteckte Kosten. Eine Altbausanierung beginnt in der Regel ab ca. 5.000 €. Ein Festpreis ist je nach Projekt und nach vorheriger Absprache möglich.',
  },
  {
    question: 'Wie lange dauert eine komplette Elektroinstallation einer Modernisierung?',
    answer: 'Die Dauer einer Modernisierung hängt von der Größe des Projekts und dem Umfang der Arbeiten ab. Eine Standardwohnung in Bonn kann in der Regel innerhalb weniger Arbeitstage vollständig modernisiert werden. Bei größeren Projekten erstellen wir vorab einen detaillierten Zeitplan, damit Sie genau wissen, was Sie erwartet.',
  },
  {
    question: 'Wo ist Daniels Elektroinstallationen als Elektriker tätig?',
    answer: 'Wir sind als Elektriker in Bonn und dem gesamten Rhein-Sieg-Kreis tätig. Dazu gehören Bonn-Zentrum, Beuel, Bad Godesberg, Bornheim, Alfter, Meckenheim und weitere Gemeinden. Wir sind auch im Raum Köln durch Wohnungsbau und Immobilienservice vertreten.',
  },
  {
    question: 'Bieten Sie Sprechanlagen und Smart-Home-Lösungen in Bonn an?',
    answer: 'Ja, wir planen und installieren moderne Audio- und Video-Sprechanlagen von Legrand-Bticino – inklusive Zugangskontrolle, Infomodulen und 2-Draht-Bus-Technologie. Außerdem unterstützen wir Sie bei intelligenter Lichtsteuerung und vernetzter Haustechnik für Ihr Zuhause in Bonn.',
  },
  {
    question: 'Gibt es einen Elektro-Notdienst in Bonn?',
    answer: 'Bei Elektro-Notfällen während unserer Öffnungszeiten in Bonn versuchen wir, so schnell wie möglich vor Ort zu sein – in vielen Fällen noch am selben Tag. Rufen Sie uns direkt an unter +49 228 23 46 44. Ein klassischer Notdienst außerhalb der Öffnungszeiten ist nur in Ausnahmefällen und nach vorheriger Absprache möglich, zum Beispiel mit Wohnungsbaugesellschaften.',
  },
  {
    question: 'Was ist ein E-Check und brauche ich einen?',
    answer: 'Der E-Check ist eine normgerechte Prüfung Ihrer gesamten Elektroanlage. Er ist wichtig für Ihre Sicherheit, den Versicherungsschutz und die Werterhaltung Ihrer Immobilie in Bonn. Wir empfehlen einen E-Check alle 4 Jahre.',
  },
  {
    question: 'Installieren Sie Rauchwarnmelder nach DIN 14676 in Bonn?',
    answer: 'Ja, wir installieren und warten Rauchwarnmelder normgerecht nach DIN 14676. In NRW besteht Rauchwarnmelderpflicht – wir sorgen dafür, dass Ihre Immobilie die gesetzlichen Anforderungen erfüllt.',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 bg-[#F4F8F4]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <span className="text-[#10B981] font-['Manrope'] text-sm font-semibold tracking-[0.2em] uppercase">
            FAQ
          </span>
          <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-bold text-[#1A3A22] tracking-tight mt-3 mb-4">
            Häufige Fragen an Ihren <span className="text-[#2D5A27]">Elektriker in Bonn</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, idx) => (
              <AccordionItem
                key={idx}
                value={`faq-${idx}`}
                data-testid={`faq-item-${idx}`}
                className="bg-white border border-gray-100 px-6 data-[state=open]:border-[#2D5A27]/20 transition-colors"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${idx}`}
                  className="font-['Outfit'] text-[#1A3A22] font-semibold text-base sm:text-lg hover:text-[#2D5A27] hover:no-underline py-5"
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-['Manrope'] text-gray-600 text-sm sm:text-base leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
